module.exports = __webpack_public_path__ + "img/type-square.9aa59149.svg";